var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data-container"},[_c('img',{attrs:{"src":require("../../assets/icons/noplan.png")}}),_c('span',[_vm._v(_vm._s(_vm.text || '暂无数据'))]),_c('button',{on:{"click":_vm.back}},[_vm._v("前往首页")])])}
var staticRenderFns = []

export { render, staticRenderFns }